module.exports = __webpack_public_path__ + "img/third.7cea45af.png";